

import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicContractorDto } from '@cradua/data';
import {User} from '@cradua/domain';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../../../../../../apps/epims/mrsoftepims/src/app/services/auth.service';

@Component({
  selector: 'cradua-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent{

  seismiccontractorForm: FormGroup;
  seismiccontractorFormArray: FormGroup;
  control = new FormControl();
  @Input() seismiccontractors: SeismicContractorDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismiccontractor = new EventEmitter<SeismicContractorDto[]>()
  @Output() deleteSeismicContractorEvent = new EventEmitter<any>()
  @Output() searchevent = new EventEmitter<any>()
  user: User;
    selectedSeismicContractor: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     public authServ: AuthenticationService
     ) {}

    ngOnChanges() {
      this.user = this.authServ.getUser();
      // console.log('reaching contractor table')
      this.createSeismicContractorForm();
    }

    searchContractors(contractorName) {
    this.searchevent.emit(contractorName)
    }
    createSeismicContractorForm() {
      this.seismiccontractorForm = this.fb.group({
        ContractorName: ['', Validators.required],
        PhoneNo: ['', Validators.required],
        Email: ['', Validators.required],
        Address: ['', Validators.required],
        Website: [''],
        id: null
        });
        this.seismiccontractorFormArray = this.fb.group({ SeismicContractors: this.fb.array([])
          });
        this.setSeismicContractor();
    }

  // method to display seismiccontractors
  setSeismicContractor() {
    const control  = this.seismiccontractorFormArray.controls.SeismicContractors as FormArray;
    this.seismiccontractors.forEach( e => {
      control.push(
        this.fb.group(e)
      );
    });
  }


  // method to add SeismicContractor
  addSeismicContractor(value: SeismicContractorDto) {
    const control  = this.seismiccontractorFormArray.controls.SeismicContractors as FormArray;
    control.insert(0,
          this.fb.group(value)
       );
  }

  selectSeismicContractor(value) {}

  // method to delete seismiccontractor from arrary list
  deleteSeismicContractor(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismiccontractorFormArray.controls.SeismicContractors as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismiccontractors.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismiccontractors[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicContractorDto) {
    if(this.seismiccontractorForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismiccontractorFormArray.get('SeismicContractors')['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.addSeismicContractor(formValue);
    }
    this.selectedIndex = null;
    this.seismiccontractorForm.reset()
  }

  onEdit(index, value: SeismicContractorDto) {
    // console.log(index, value)
    this.selectedIndex = index;
    this.seismiccontractorForm.patchValue(value);
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismiccontractorForm.reset();
  }

  onSubmit(formValue: SeismicContractorDto[]) {
  this.seismiccontractor.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicContractorEvent.emit(this.filteredDelete);
  }
  }

}
